import * as moment from 'moment'
import * as tz from 'moment-timezone'
import store from '../store'
import i18next from 'i18next'

export function fDateTime(d) {
    let format = ''
    let timezone = moment.tz.guess()

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM/YYYY HH:mm:ss'
        break
        default: format = 'MM-DD-YYYY HH:mm:ss'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDateTimeEN(d) {
    let timezone = moment.tz.guess()
    let format = 'MM-DD-YYYY HH:mm:ss'
    return moment(d).tz(timezone).format(format)
}

export function fDateTimeNoTimezone(d) {
    let format = ''
    let timezone = 'Etc/GMT'

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM/YYYY HH:mm:ss'
        break
        default: format = 'MM-DD-YYYY HH:mm:ss'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDate(d) {
    let format = ''
    let timezone = moment.tz.guess()

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM/YYYY'
        break
        default: format = 'MM-DD-YYYY'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDateNoTimezone(d) {
    let format = ''
    let timezone = 'Etc/GMT'

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM/YYYY'
        break
        default: format = 'MM-DD-YYYY'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDateNoTimezoneNoYear(d) {
    let format = ''
    let timezone = 'Etc/GMT'

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM'
        break
        default: format = 'MM-DD'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDateTimeTimezone(d, timezone) {
    return moment(d).tz(timezone)
}

export function fDateTimeTimezoneFormated(d, timezone) {
    let format = ''

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM/YYYY HH:mm'
        break
        default: format = 'MM-DD-YYYY HH:mm'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDateTimezoneFormated(d, timezone) {
    let format = ''

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM/YYYY'
        break
        default: format = 'MM-DD-YYYY'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fTimeTimezoneFormated(d, timezone) {
    return moment(d).tz(timezone).format('HH:mm')
}

export function fDateNoTimezoneOpen(d) {
    let format = ''
    let timezone = 'Etc/GMT'

    if (store.getters['common/id_user_language_selected']) {
        switch(store.getters['common/id_user_language_selected']) {
            case 1:
            case 3: format = 'DD/MM/YYYY'
            break
            default: format = 'MM-DD-YYYY'
            break
        }
    }
    else if (i18next.language) {
        switch(i18next.language) {
            case 'pt':
            case 'es': format = 'DD/MM/YYYY'
            break
            default: format = 'MM-DD-YYYY'
            break
        }
    }

    return moment(d).tz(timezone).format(format)
}

export function fHour(d) {
    let timezone = moment.tz.guess()

    return moment(d).tz(timezone).format('HH:mm')
}

export function fHourNoTimezone(d) {
    return moment(d).format('HH:mm')
}

export function fDateDB(d) {
    let timezone = moment.tz.guess()

    return moment(d).tz(timezone).format('YYYY-MM-DD')
}

export function fDateDBDatePicker(d) {
    let timezone = moment.tz.guess()

    return moment(d, mDate()).tz(timezone).format('YYYY-MM-DD')
}

export function fDateTimeDB(d) {
    let timezone = moment.tz.guess()

    return moment(d).tz(timezone).format('YYYY-MM-DDTHH:mm:ss.SSS')
}

export function fDatePicker(d) {
    let timezone = moment.tz.guess()

    return moment(d).tz(timezone).format('YYYY/MM/DD')
}

export function fDateText(d) {
    return moment(d).locale(i18next.language).format('LL')
}

export function fYearMonth(d) {
    return moment(d).format('YYYY-MM')
}

export function fDay(d) {
    return moment(d).format('DD')
}

export function fMonth(d) {
    return moment(d).locale(i18next.language).format('MMMM')
}

export function fYearMonthLocalized(d) {
    let format = ''
    let timezone = moment.tz.guess()

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'MM/YYYY'
        break
        default: format = 'MM-YYYY'
        break
    }

    return moment(d).tz(timezone).format(format)
}

export function fDateTimeAgo(d) {
    return moment(d).locale(i18next.language).fromNow()
}

export function mDate() {
    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: return 'DD/MM/YYYY'
        default:  return 'MM-DD-YYYY'
    }
}

export function mDateMonth() {
    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: return 'DD/MM'
        default:  return 'MM-DD'
    }
}

export function fDateMonth(d) {

    let format = ''
    let timezone = moment.tz.guess()

    switch(store.getters['common/id_user_language_selected']) {
        case 1:
        case 3: format = 'DD/MM'
        default: format = 'MM-DD'
    }

    return moment(d).tz(timezone).format(format)
}

export function dateDifferece(d) {
    let date1 = moment(d).tz('Etc/GMT')
    let date2 = moment(new Date())

    return moment.duration(date1.diff(date2)).asDays()
}

export function dateDiffereceTimezoneMinutes(d) {
    let timezone = moment.tz.guess()
    let date1 = moment(d).tz(timezone)
    let date2 = moment(new Date())

    return moment.duration(date1.diff(date2)).asMinutes()
}

export function dateDiffereceTimezoneDays(d) {
    let timezone = moment.tz.guess()
    let date1 = moment(d).tz(timezone)
    let date2 = moment(new Date())

    return moment.duration(date1.diff(date2)).asDays()
}

export function isSameDay(d) {
    return moment(d).isSame(new Date(), 'day')
}

export function timezoneHuman(d) {
    return moment.tz(new Date(), d).format('Z')
}

export function secondsToMinutes(d) {
    return moment.utc(moment.duration(d, 'seconds').asMilliseconds()).format('mm:ss')
}

export const apiRequestTimeDelay = -3

export default { fDateTime, fDateTimeNoTimezone, fDate, fDateNoTimezone, fDateNoTimezoneNoYear, fDateTimeTimezoneFormated, fDateTimezoneFormated, fTimeTimezoneFormated, fDateTimeTimezone, fDateNoTimezoneOpen, fHour, fHourNoTimezone, fDateDB, fDateDBDatePicker, fDateTimeDB, fDatePicker, fDateText, fYearMonth, fDay, fMonth, fYearMonthLocalized, fDateTimeAgo, mDate, fDateMonth, mDateMonth, dateDifferece, dateDiffereceTimezoneMinutes, dateDiffereceTimezoneDays, isSameDay, timezoneHuman, secondsToMinutes, fDateTimeEN, apiRequestTimeDelay }